var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui secondary pointing menu"},[_c('router-link',{staticClass:"item",attrs:{"to":_vm.offersToConfig,"exact":true}},[_vm._v("Angebote")]),_c('router-link',{staticClass:"item",attrs:{"to":_vm.addressesToConfig,"exact":true}},[_vm._v("Adressen")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }